import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { BiometricsAvailable } from "./fingerprint.service";

@Injectable()
export class FingerprintMockService {

    /**
   * Use this method in Login page to check if user
   * should be redirected to the Biometric Activator
   */
    public async checkIfNeedsBiometric(user: string) {
        return Promise.resolve(false);
    }

    /**
   * Use in Login page to show the Biometric Activator page
   * @param user User
   * @param password Password
   * @param callbackUrl URL to return after success or fail
   */
  public showBiometricActivator(user: string, password: string, callbackUrl: string) { }

  /**
   * Use in Login page to open Biometric prompt
   * @param user string
   */
   public async showBiometricPrompt(user: string) {
       return Promise.resolve({ user, password: null })
   }

   /**
   * Checks and returns which biometrics methods are available
   * for the current device
   * @returns Promise<Biometric[]>
   */
    public async retrieveDeviceBiometrics(): Promise<BiometricsAvailable> {
        return {
            face: false,
            touch: false
        }
    }

    /**
   * Shows the FaceID dialog to the user
   * @param user Client user
   * @returns Promise<void>
   */
  public async activateFaceID(user: string, password: string) { }

  /**
   * Shows the TouchID dialog to the user
   * @param user Client user
   * @param password Client password
   */
   public activateTouchID(user: string, password: string) { }

   public async isBiometricActive(user: string, biometricType: keyof BiometricsAvailable): Promise<any> { }

   public async clearBiometricData(user: string, biometricType: keyof BiometricsAvailable) { }
   public async disableBiometricData(user: string, biometricType: keyof BiometricsAvailable) { }

   public showFingerprintId(user: string, biometricType: keyof BiometricsAvailable) {
    return of(false);
  }
}